import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { hall } from "../../../../service";
import {
    Button,
    Input,
    Divider,
    Space,
    DatePicker,
    Card,
    Avatar,
    message,
    Select,
    Form,
} from 'antd';
import {
    ArrowLeftOutlined,
} from '@ant-design/icons';
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';
import './index.scss';

export default function OrderView() {
    const { id } = useParams()
        , navigate = useNavigate()
        , [form] = Form.useForm()
        , [record, setRecord] = useState({})
        , [classify_, setClassify_] = useState(null)
        , { serverUrl } = useSelector(state => state.siteInfo)

    useEffect(() => {
        if (id) {
            async function fetchData() {
                const { data } = await hall.apiHall.getDetails(id)
                setRecord(data)
            }
            fetchData()
        }
    }, [])

    const onFinish = async () => {
        try {
            const values = await form.validateFields()
                , params = {
                    ...values,
                    title: classify_,
                    orderUserId: record.userId,
                    startDate: dayjs(values.startDate).format("YYYY-MM-DD"),
                    endDate: dayjs(values.endDate).format("YYYY-MM-DD")
                }
                , data = await hall.apiOrder.add(params)
            message.success("提交成功！")
            setTimeout(() => {
                navigate(-1)
            }, 1000);
        } catch (error) {
            console.log(error);
        }
    }

    return (
        <div className='services-order-content'>
            <div className='details-header'>
                <Button
                    icon={<ArrowLeftOutlined />}
                    type='text'
                    onClick={() => navigate(-1)}
                >返回</Button>
            </div>

            <div className='container-display-center'>
                <Form
                    form={form}
                    name='order.form'
                    onFinish={onFinish}
                    className='order-form'
                >
                    <Form.Item noStyle>
                        <Space.Compact block>

                            <Form.Item
                                name='classify'
                                label='服务类型'
                                rules={[{ required: true, message: '请选择' }]}
                                style={{ width: 'calc(50% - 8px)', marginRight: 8 }}
                            >
                                <Select
                                    options={record.classifyInfo}
                                    fieldNames={{ label: 'classifyName', value: 'classify' }}
                                    placeholder='请选择'
                                    onChange={(value, { classifyName }) => setClassify_(classifyName)}
                                />
                            </Form.Item>

                            <Form.Item
                                name='content'
                                label='数量'
                                rules={[{ required: true, message: '请填写' }]}
                                style={{ width: 'calc(50% - 8px)', marginRight: 8 }}

                            >
                                <Input placeholder='请填写亩/斤等' />
                            </Form.Item>

                        </Space.Compact>
                    </Form.Item>

                    <Form.Item noStyle>
                        <Space.Compact block>

                            <Form.Item
                                name='startDate'
                                label='开始日期'
                                style={{ width: 'calc(50% - 8px)', marginRight: 8 }}
                            >
                                <DatePicker style={{ width: '100%' }} />
                            </Form.Item>

                            <Form.Item
                                name='endDate'
                                label='结束日期'
                                style={{ width: 'calc(50% - 8px)', marginRight: 8 }}
                            >
                                <DatePicker style={{ width: '100%' }} />
                            </Form.Item>

                        </Space.Compact>
                    </Form.Item>

                    <Form.Item
                        name='remark'
                        label='备注'
                    >
                        <Input.TextArea placeholder='请填写' />
                    </Form.Item>

                    <Divider />

                    <Form.Item noStyle>
                        <Space.Compact block>

                            <Form.Item
                                name='contactUser'
                                label='联系人'
                                rules={[{ required: true, message: '请填写' }]}
                                style={{ width: 'calc(50% - 8px)', marginRight: 8 }}
                            >
                                <Input placeholder='请填写' />
                            </Form.Item>

                            <Form.Item
                                name='contactPhone'
                                label='联系方式'
                                rules={[{ required: true, message: '请填写' }]}
                                style={{ width: 'calc(50% - 8px)', marginRight: 8 }}
                            >
                                <Input placeholder='请填写' />
                            </Form.Item>

                        </Space.Compact>
                    </Form.Item>

                    <Form.Item
                        name='address'
                        label='服务地址'
                        rules={[{ required: true, message: '请填写' }]}
                    >
                        <Input.TextArea placeholder='请填写' />
                    </Form.Item>

                    <Divider orientation="left">确认服务集团</Divider>

                    <Card
                        style={{
                        }}
                    >
                        <Card.Meta
                            avatar={<Avatar
                                src={serverUrl + record.imageUrl}
                                style={{ width: '70px', height: '70px' }}
                            />}
                            title={record.name}
                            description={record.address}
                        />
                    </Card>

                    <Form.Item>
                        <Button
                            type='primary'
                            size='large'
                            danger
                            style={{ float: 'right', marginTop: 20 }}
                            htmlType="submit"
                        >提交订单</Button>
                    </Form.Item>

                </Form>
            </div>
        </div>
    )
}
